import { OutboundInvoiceSchema } from "@redotech/redo-model/balance/outbound-invoice";
import * as z from "zod/v4";

export const getOutboundInvoice = {
  name: "getOutboundInvoice" as const,
  input: z.object({ key: z.number() }),
  output: OutboundInvoiceSchema.nullable(),
};
